import { render, staticRenderFns } from "./meetingPapers.vue?vue&type=template&id=3bb391e4&scoped=true&"
import script from "./meetingPapers.vue?vue&type=script&lang=js&"
export * from "./meetingPapers.vue?vue&type=script&lang=js&"
import style0 from "./meetingPapers.vue?vue&type=style&index=0&id=3bb391e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb391e4",
  null
  
)

export default component.exports